import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { createPortal } from 'react-dom';

import Icon from '../../../../shared/_TBComponents/Icon';
import {
  useActionMenu, ActionMenuWrapper, ActionMenuContainer, ActionMenuDivider, ActionMenuItemButton,
} from './tables/MaxesGoalsTable';

const MenuButton = styled.button`
  border: 1px solid #D6D6D6;
  border-radius: 4px;
  background: #FFFFFF;
  padding: 8px 16px;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: #F7F7F7;
  }
`;

const MenuItem = styled(ActionMenuItemButton)`
  &:disabled {
    opacity: 0.4;
    cursor: default;
    background: none;
  }
`;

const ManageMenuItem = ({ item, onClose }) => {
  const handleClick = () => {
    onClose();
    if (item.onClick) item.onClick();
  };
  return (
    <MenuItem
      type='button'
      role='menuitem'
      disabled={item.disabled}
      title={item.disabled ? item.disabledReason : undefined}
      onClick={handleClick}
    >
      <Icon icon={item.icon} size={16} color={item.iconColor || '#1A1A1A'} />
      {item.label}
    </MenuItem>
  );
};

const itemShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  divider: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.string,
  iconColor: PropTypes.string,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  onClick: PropTypes.func,
});

ManageMenuItem.propTypes = {
  item: itemShape.isRequired,
  onClose: PropTypes.func.isRequired,
};

const ManageMenu = ({ items }) => {
  const {
    isOpen, menuStyle, menuRef, buttonRef, openMenu, close,
  } = useActionMenu();

  return (
    <ActionMenuWrapper>
      <MenuButton
        ref={buttonRef}
        type='button'
        onClick={openMenu}
        aria-haspopup='menu'
        aria-expanded={isOpen}
      >
        Manage ▾
      </MenuButton>
      {isOpen && createPortal(
        <ActionMenuContainer ref={menuRef} style={menuStyle} role='menu'>
          {items.map((item) => (item.divider ? (
            <ActionMenuDivider key={item.key} />
          ) : (
            <ManageMenuItem key={item.key} item={item} onClose={close} />
          )))}
        </ActionMenuContainer>,
        document.body,
      )}
    </ActionMenuWrapper>
  );
};

ManageMenu.propTypes = {
  items: PropTypes.arrayOf(itemShape).isRequired,
};

export default ManageMenu;
